var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "foot" }, [
    !_vm.isMj
      ? _c("div", { staticClass: "w1200 t_center" }, [
          _vm._m(0),
          _c("div", { staticClass: "f_line" }),
          _c("div", { staticClass: "box35" }),
          _c("div", { staticClass: "f_codelie clear pad10_l" }, [
            _c("div", { staticClass: "t_left float-left" }, [
              _c("h2", { staticClass: "f18" }, [_vm._v("进货指南")]),
              _c("ul", [
                _c("li", [
                  _c(
                    "a",
                    {
                      staticClass: "f14 gray_3",
                      attrs: {
                        href: _vm.app + "goods/tofootindex/memberregistGuide.do"
                      }
                    },
                    [_vm._v("用户注册")]
                  )
                ]),
                _c("li", [
                  _c(
                    "a",
                    {
                      staticClass: "f14 gray_3",
                      attrs: {
                        href:
                          _vm.app + "goods/tofootindex/shoppingprocessGuide.do"
                      }
                    },
                    [_vm._v("购物流程")]
                  )
                ]),
                _c("li", [
                  _c(
                    "a",
                    {
                      staticClass: "f14 gray_3",
                      attrs: {
                        href:
                          _vm.app + "goods/tofootindex/commonproblemGuide.do"
                      }
                    },
                    [_vm._v("常见问题")]
                  )
                ])
              ])
            ]),
            _c("div", { staticClass: "t_left float-left" }, [
              _c("h2", { staticClass: "f18" }, [_vm._v("支付方式")]),
              _c("ul", [
                _c("li", [
                  _c(
                    "a",
                    {
                      staticClass: "f14 gray_3",
                      attrs: {
                        href: _vm.app + "goods/tofootindex/payment1Type.do"
                      }
                    },
                    [_vm._v("在线支付")]
                  )
                ]),
                _c("li", [
                  _c(
                    "a",
                    {
                      staticClass: "f14 gray_3",
                      attrs: {
                        href: _vm.app + "goods/tofootindex/payment2Type.do"
                      }
                    },
                    [_vm._v("当面结算")]
                  )
                ])
              ])
            ]),
            _c("div", { staticClass: "t_left float-left" }, [
              _c("h2", { staticClass: "f18" }, [_vm._v("配送服务")]),
              _c("ul", [
                _c("li", [
                  _c(
                    "a",
                    {
                      staticClass: "f14 gray_3",
                      attrs: {
                        href:
                          _vm.app + "goods/tofootindex/distribution1Service.do"
                      }
                    },
                    [_vm._v("配送范围")]
                  )
                ]),
                _c("li", [
                  _c(
                    "a",
                    {
                      staticClass: "f14 gray_3",
                      attrs: {
                        href:
                          _vm.app + "goods/tofootindex/distribution2Service.do"
                      }
                    },
                    [_vm._v("自提服务")]
                  )
                ])
              ])
            ]),
            _c("div", { staticClass: "t_left float-left" }, [
              _c("h2", { staticClass: "f18" }, [_vm._v("售后保障")]),
              _c("ul", [
                _c("li", [
                  _c(
                    "a",
                    {
                      staticClass: "f14 gray_3",
                      attrs: {
                        href: _vm.app + "goods/tofootindex/returnPolicy.do"
                      }
                    },
                    [_vm._v("退换政策")]
                  )
                ])
              ])
            ]),
            _c("div", { staticClass: "t_left float-left" }, [
              _c("h2", { staticClass: "f18" }, [_vm._v("商家合作")]),
              _c("ul", [
                _c("li", [
                  _c(
                    "a",
                    {
                      staticClass: "f14 gray_3",
                      attrs: {
                        href: _vm.app + "goods/tofootindex/processEnter.do"
                      }
                    },
                    [_vm._v("商家入驻")]
                  )
                ]),
                _c("li", [
                  _c(
                    "a",
                    {
                      staticClass: "f14 st gray_3",
                      attrs: {
                        href: _vm.app + "goods/tofootindex/basicRules.do"
                      }
                    },
                    [_vm._v("平台规则")]
                  )
                ]),
                _c("li", [
                  _c(
                    "a",
                    {
                      staticClass: "f14 st gray_3",
                      attrs: {
                        href: _vm.app + "goods/tofootindex/feedStand.do"
                      }
                    },
                    [_vm._v("行业标准")]
                  )
                ])
              ])
            ]),
            _vm._m(1)
          ])
        ])
      : _vm._e(),
    !_vm.isMj ? _c("div", { staticClass: "box40" }) : _vm._e(),
    _c("div", { staticClass: "coryright" }, [
      _c("div", { staticClass: "w1200 t_center white" }, [
        _c("div", { staticClass: "cor-link" }, [
          _c(
            "a",
            { attrs: { href: _vm.app + "goods/tofootindex/aboutNxin.do" } },
            [_vm._v("关于农信商城")]
          ),
          _vm._v("- "),
          _c(
            "a",
            { attrs: { href: _vm.app + "goods/tofootindex/contactUS.do" } },
            [_vm._v("联系我们")]
          ),
          _vm._v("-\n        "),
          _c(
            "a",
            { attrs: { href: _vm.app + "goods/tofootindex/qualification.do" } },
            [_vm._v("资质文件")]
          ),
          _vm._v("- "),
          _c("a", { attrs: { href: _vm.app + "mj/toSetbacks.do" } }, [
            _vm._v("卖家中心")
          ]),
          _vm._v("-\n        "),
          _c("a", { attrs: { href: "" + _vm.app } }, [_vm._v("风险须知")])
        ]),
        _c("a", { attrs: { href: "https://beian.miit.gov.cn/" } }, [
          _vm._v("浙ICP备17059353号")
        ]),
        _c("p", { staticClass: "white" }, [
          _vm._v("Copyright © 2017-2022 浙江农信数智电子商务有限公司版权所有")
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "clear t_center" }, [
      _c("li", [
        _c("span", { staticClass: "f20 gray_3 icon0" }, [_vm._v("名牌汇聚")])
      ]),
      _c("li", [
        _c("span", { staticClass: "f20 gray_3 icon1" }, [_vm._v("优质优价")])
      ]),
      _c("li", [
        _c("span", { staticClass: "f20 gray_3 icon2" }, [_vm._v("特级服务")])
      ]),
      _c("li", [
        _c("span", { staticClass: "f20 gray_3 icon3" }, [_vm._v("正品保障")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "float-left pad70_l" }, [
      _c("div", { staticClass: "float-left" }, [
        _c("p", { staticClass: "f14 st gray_3 text-center" }, [
          _vm._v("智农通客户端")
        ])
      ]),
      _c("div", { staticClass: "float-right pad70_l" }, [
        _c("p", { staticClass: "f14 gray_3 t_center" }, [
          _vm._v("农信商城微信")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }